import { AbstractCCStructureItem } from "./CCStructureItem";
import { DefaultStyling } from "./CCStyling";
import { CCWrapper } from "./components/Form";
import { CCStructureItem } from "./types/structure";
export class CCStructure {
  // This is like the 'format input' object part that defines the layout of tab
  // name: label next to the text box
  // type: integer, float, string, header, paragraph, select (option), previous (last year's value)
  public structure: CCStructureItem[];
  constructor(defaultStructure: CCStructureItem[] = []) {
    this.structure = defaultStructure;
  }
  public replace(key: string, value: any): number {
    let i = this.structure.findIndex(
      (element) => "key" in element && element.key == key
    );
    if (i != -1) {
      this.structure.splice(i, 1, value);
    }
    return i;
  }
  public insertAfter(key: string, value: any): number {
    let i = this.structure.findIndex(
      (element) => "key" in element && element.key == key
    );
    if (i != -1) {
      this.structure.splice(++i, 0, value);
    }
    return i;
  }
  public insertAt(index: number, value: any): number {
    this.structure.splice(index, 0, value);
    return ++index;
  }
  public insertBefore(key: string, value: any): number {
    let i = this.structure.findIndex(
      (element) => "key" in element && element.key == key
    );
    if (i != -1) {
      this.structure.splice(i--, 0, value);
    }
    return i;
  }
  public getIndex(key: string): number {
    return this.structure.findIndex(
      (element) => "key" in element && element.key == key
    );
  }
  public getIndexByName(name: string): number {
    return this.structure.findIndex(
      (element) => "name" in element && element.name == name
    );
  }
  public remove(key: string): void {
    const i = this.structure.findIndex(
      (element) => "key" in element && element.key == key
    );
    if (i != -1) this.structure.splice(i, 1);
  }
  public removeByName(name: string): void {
    const i = this.structure.findIndex(
      (element) => "name" in element && element.name == name
    );
    if (i != -1) this.structure.splice(i, 1);
  }
  public instantiateItems(items: CCStructureItem[]): AbstractCCStructureItem[] {
    return items.map((item, index) =>
      AbstractCCStructureItem.getInstance(item, index, this)
    );
  }
  public generateHTML(elements: CCStructureItem[] = this.structure): JQuery {
    const genRoot: JQuery = $("<div>");
    const noteBuffer = [];
    const instantiated = this.instantiateItems(elements);
    for (let i = 0; i < instantiated.length; ++i) {
      const inst = instantiated[i];
      genRoot.append(inst.generateHTML());
      noteBuffer.push(...inst.processNotes(genRoot));
    }
    if (noteBuffer.length) {
      for (let i = 0; i < noteBuffer.length; i++) {
        genRoot.append(
          CCWrapper(
            `<span>${noteBuffer[i].ref + noteBuffer[i].text}</span>`,
            "",
            DefaultStyling.note
          )
        );
      }
    }
    return genRoot.children();
  }
}
